

export const soraHero = {
    title: 'Sora 2 AI 影片生成器',
    tags: '無浮水印 • 無邀請碼 • 無需下載 App',
    desc:
      '體驗 OpenAI 最新 Sora 2 模型。把文字或圖片轉為逼真影片，具備進階運動與物理一致性。適合創作與社群內容。'
  };
